<template>
  <div id="AttendanceICAReport">
    <div class="p-5 ">
      <div class="row header mb-5">
        <div class="col-lg-5 ">
          <h3 class="text-left mb-3">ATTENDANCE REPORT FOR ICA</h3>
        </div>
        
        <div class="datatable-form__header atr-header-wrap mb-4">

          <div class="datatable-form__input form-group flex-1 text-left">
            <label>Level</label>
            <el-select placeholder="Select" v-model="levelSelected" class="ddlSearchStatua" @change="levelChange()">
              <el-option
                  v-for="Level  in levels"
                  :label="Level.CRS_Course_Name"
                  :value="Level.PK_Course_ID"
              >
              </el-option>
            </el-select>
          </div>
          <div class="datatable-form__input form-group flex-1 text-left">
            <label>Class</label>
            <el-select placeholder="Select" v-model="classSelected"  class="ddlSearchStatua" @change="bindStudents()">
              <el-option
                  v-for="Class in classes"
                  :label="Class.CLS_ClassName"
                  :value="Class.PK_Class_ID"
              >
              </el-option>
            </el-select>
          </div>
          <div class="datatable-form__input form-group flex-1 text-left">
            <label>Select Date</label>
            <el-date-picker
                v-model="inputDate"
                type="monthrange"
                range-separator="To"
                start-placeholder="Start month"
                end-placeholder="End month"
                format="MM/yyyy"
                value-format="MM/yyyy">
<!--                v-model="inputFromDate"-->
<!--                type="daterange"-->
<!--                range-separator="To"-->
<!--                start-placeholder="Start date"-->
<!--                end-placeholder="End date"-->
<!--                @change="testDate"-->
            </el-date-picker>
          </div>
         
        </div>
        <div class="datatable-form__header atr-header-wrap mb-4">

          <div class="datatable-form__input form-group flex-1 text-left">
            <label>Student Type</label>
            <el-select placeholder="Select" v-model="studentType" class="ddlSearchStatua" multiple @change="bindStudents()">
              <el-option
                  v-for="type in studentTypes"
                  :label="type.student_type"
                  :value="type.student_type"
              >
              </el-option>
            </el-select>
          </div>
          <div class="datatable-form__input form-group flex-1 text-left">
            <label>Student</label>
            <el-select placeholder="Select" v-model="studentSelected" class="ddlSearchStatua" >
              <el-option
                  v-for="student in students"
                  :label="student.Full_Name + ' ' +student.Last_name "
                  :value="student.Index_No"
              >
              </el-option>
            </el-select>
          </div>
          <div class="datatable-form__input form-group flex-1 text-left"><label></label>
            <b-button @click="handleReport()" >Search</b-button>
          </div>
          
        </div>
        <div class="datatable-form__header atr-header-wrap mb-4">
          <div class="datatable-form__input form-group flex-1 text-left"><label></label>
            <el-select v-model="modeSelected"
                       placeholder="lang('Mode Select')"
 
                       id="mode" >
              <el-option
                  v-for="item in modes"
                  :key="item"
                  :label="item"
                  :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="datatable-form__input form-group flex-1 text-left" ><label></label>
            <label/>
          </div>
          <div class="datatable-form__input form-group flex-1 text-left" ><label></label>
            <b-button @click="exportCSV()" :disabled="modeSelected===modes[0]" >Export</b-button>

          </div>
         
        </div>
        
        <div class="datatable-form__header atr-header-wrap mb-4"  v-if="tableDetail.length!==0 && modeSelected===modes[0]">
          <el-table :data="tableDetail " >
            <el-table-column prop="CRS_Course_Name" label="Course Name" />
            <el-table-column prop="CLS_ClassName" label="Class Name" />
            <el-table-column prop="att_stud_no" label="Index No" />
            <el-table-column prop="Full_Name" label="Full Name" />
            <el-table-column prop="ID_Number" label="ID Number" />
            <el-table-column prop="att_in_datetime" label="Time In" />
            <el-table-column prop="student_type" label="Student Type" />
            <el-table-column prop="att_remark" label="Remark" />
            <el-table-column prop="att_status" label="Status" />

            
          </el-table>
        </div>

        <div class="datatable-form__header atr-header-wrap mb-4" v-if="tableDetailSummary.length!==0 && modeSelected===modes[1]">
          
          <el-table :data="tableDetailSummary " >
            <el-table-column prop="CRS_Course_Name" label="Course Name" />
            <el-table-column prop="CLS_ClassName" label="Class Name" />
            <el-table-column prop="att_stud_no" label="Index No" />
            <el-table-column prop="Full_Name" label="Full Name" >
              <template #default="scope">
                {{scope.row.Full_Name+" "+scope.row.Last_name }}
              </template>
            </el-table-column>
            <el-table-column prop="ID_Number" label="ID Number" />
            <el-table-column prop="student_type" label="Student Type" />
            <el-table-column prop="Month" label="Month" />
              <el-table-column label="Status" v-if="isMiddleton">
                  <el-table-column prop="Present" label="Present" :width="statusColWidth" />
                  <el-table-column prop="LateArrival" label="Late" :width="statusColWidth" />
                  <el-table-column prop="EarlyDismissal" label="Early Dismissal" :width="statusColWidth" />
                  <el-table-column prop="Absent" label="Absent" :width="statusColWidth" />
                  <el-table-column prop="AuthorizedAbsence" label="Authorized Absence" :width="statusColWidth" />
              </el-table-column>
              <el-table-column label="Status" v-else>
                  <el-table-column prop="Present" label="Present" :width="statusColWidth" />
                  <el-table-column prop="Late" label="Late" :width="statusColWidth" />
                  <el-table-column prop="SentHome" label="Sent Home" :width="statusColWidth" />
                  <el-table-column prop="Absent" label="Absent" :width="statusColWidth" />
                  <el-table-column prop="Sick" label="Sick" :width="statusColWidth" />
              </el-table-column>
            <el-table-column prop="Percentage" label="Days In school" width="150" />
            <el-table-column prop="Regst_date" label="Registration Date" />

          </el-table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import DataSource from "@/data/datasource";
import Export_CSV from "@/components/Export_CSV"; 
import {lang, selectedLocale} from '../locale/index';
import {Datetime} from "vue-datetime";
import { checkIsMiddleton } from "@/helper/util_custom";


export default {
  name: "AttendanceView",
  async created() {
    this.schID = Cookies.get('schoolSession');
    await this.bindLevels();
    await this.bindStudentType();
    this.modeSelected = this.modes[1];
  },
  data() {
    return {
        statusColWidth: "100vw",
      schID : '',
      inputDate: '',
      
      levelSelected: '',
      levels: [],

      classSelected: '',
      classes: [],

      studentType: [],
      studentTypes: [],

      studentSelected: '',
      students: [],
      
      attendanceView : [],
      
      tableDetail : [],
      tableDetailSummary: [],
      
      modes : ['Individual','Summary'],
      modeSelected:'',

        isMiddleton: false
      
      
      
    }
  },
    mounted(){
        this.isMiddleton = checkIsMiddleton()
    },
  methods: {
    lang,
    
    async bindLevels() {
      try {
        const response = await DataSource.shared.getLevelList(this.schID);
        let dsLevel = response.Table;
        dsLevel.forEach(m => {
          let temp  ={
            CRS_Course_Name :m.CRS_Course_Name,
            PK_Course_ID :m.PK_Course_ID
          }
          this.levels.push(temp);
        });
      } catch (e) {
        this.results = e;
      }
    },
    
    async levelChange() {
      this.$vs.loading();
      await this.reset();
      await this.bindClasses();
      this.$vs.loading.close();
    },
    
    async bindClasses() {
      try {
        const response = await DataSource.shared.getClassByLevel(this.levelSelected );
        if (response) {
          let cls = response.Table;
          cls.forEach(m => {
            let temp  ={
              PK_Class_ID :m.PK_Class_ID,
              CLS_ClassName :m.CLS_ClassName +" ("+m.CLS_Batch+")"
            }
            this.classes.push(temp);
            
          });
        }
      } catch (e) {
        this.results = e;
      }
    },
    
    
    async bindStudentType() {

      try {
        let jsonString = '"Residency Status":"Residency Status"';
        jsonString = "{" + jsonString + "}";
        const response = await DataSource.shared.getStudentDropDownList(jsonString);
        if (response) {
          let dsTypes = response.Table;

          dsTypes.forEach(m => {
            let temp  ={
              student_type :m.OPTvalue,
            }
            this.studentTypes.push(temp);
          });

        }
      } catch (e) {
        this.results = e;
      }
    },

    async bindStudents(){
      this.studentSelected = "";
      this.students = [];
      try {
        const response = await DataSource.shared.getStudentByCourseClassType(this.levelSelected,this.classSelected,this.studentType.toString());
        if (response) {
          let dsStudents = response.Table;
          dsStudents.forEach(m => {
            let temp  ={
              Index_No :m.Index_No,
              Full_Name :m.Full_Name,
              Last_name :m.Last_name
            }
            this.students.push(temp);
          });
          // this.students= dsStudents;
        }
      } catch (e) {
        this.results = e;
      }
    },
      async handleReport() {
          this.$vs.loading();
          await this.fetchReport();
          this.$vs.loading.close();
      },
    async fetchReport (){
      this.$vs.loading();
      
      this.attendanceView = [];
      this.tableDetail = [];
      this.tableDetailSummary = [];
      try {
        if(this.inputDate.length === 0){
          this.$notify.error({
            title: 'Alert',
            message: 'Please select date range'
          });
        }
        else{
          let fromDate = this.inputDate[0].split("/");
          let toDate = this.inputDate[1].split("/");
          let td = new Date(parseInt(toDate[1] ),parseInt(toDate[0]),1 );
          let newfromDate = `${fromDate[1]}-${fromDate[0]}-01`;
          let newtoDate = `${td.getFullYear()}-${td.getMonth()+1}-01`
          // let newfromDate = `1/${fromDate[0]}/${fromDate[1]}`;
          // let newtoDate = `1/${td.getMonth()+1}/${td.getFullYear()}`


          if(this.modeSelected===this.modes[0]){

            const response = await DataSource.shared.GetAttendanceWithStudentType(this.studentType.toString(),this.levelSelected,this.classSelected,this.studentSelected,newfromDate,newtoDate);
            this.tableDetail = response.Table;
            this.tableDetail.forEach(t=>{
              let newDT = new Date(t.att_in_datetime) ;
              t.att_in_datetime =newDT.toLocaleDateString() +" "+newDT.toLocaleTimeString();
            })
          }

          if(this.modeSelected===this.modes[1]){

            const response2 = await DataSource.shared.GetAttendanceWithStudentTypeSummary(this.studentType.toString(),this.levelSelected,this.classSelected,this.studentSelected,newfromDate,newtoDate);
            this.tableDetailSummary  = response2.Table;
            
            this.tableDetailSummary.forEach(t=>{
              let sum = 0;
              if (t.Present !== undefined){
                sum += t.Present;
              }
              if (t.Late !== undefined){
                sum += t.Late;
              }
              if (t.SentHome !== undefined){
                sum += t.SentHome;
              }
              let newDT = new Date(t.Regst_date) ;
              const options = { year: 'numeric', month: 'long', day: 'numeric' }
              t.Regst_date =newDT.toLocaleDateString('en',options);

              switch(t.Month){
                case 1:
                  t.Month="January";
                  // t.Percentage = (sum/16 *100).toFixed(2) ;
                  t.Percentage = sum ;
                  break;
                case 2:
                  t.Month="February";
                  t.Percentage = sum ;
                  break;
                case 3:
                  t.Month="March";
                  t.Percentage = sum ;
                  break;
                case 4:
                  t.Month="April";
                  t.Percentage = sum ;
                  break;
                case 5:
                  t.Month="May";
                  t.Percentage = sum ;
                  break;
                case 6:
                  t.Month="June";
                  t.Percentage = sum ;
                  break;
                case 7:
                  t.Month="July";
                  t.Percentage = sum ;
                  break;
                case 8:
                  t.Month="August";
                  t.Percentage = sum ;
                  break;
                case 9:
                  t.Month="September";
                  t.Percentage = sum ;
                  break;
                case 10:
                  t.Month="October";
                  t.Percentage = sum ;
                  break;
                case 11:
                  t.Month="November";
                  t.Percentage = sum ;
                  break;
                case 12:
                  t.Month="December";
                  t.Percentage = sum ;
                  break;
              }
             
            })
          }
        }
      }
      catch (e) {

        this.results = e;
        console.log(e);
        
      }
      this.$vs.loading.close();
    },
    
    async reset(){
      this.classes =[];
      this.classSelected= '';

    },
    getPercentage(present, late, sentHome){
      let sum = 0;

      let percentage = (sum)/16 *100 ;
      return sentHome
    },
    SpanCellMerge({row, column, rowIndex, columnIndex }) {

      if (columnIndex === 0) {
        const _row = this.merge[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    exportCSV() {
      let finalExportList = [];

      if (this.tableDetailSummary.length > 0) {
        this.tableDetailSummary.forEach((m, index) => {
          let tempRow = {
            'Course Name': m.CRS_Course_Name,
            'Class Name': m.CLS_ClassName,
            'att_stud_no':m.att_stud_no,
            'Full_Name': m.Full_Name + " "+  m.Last_name,
            'ID Number': m.ID_Number,
            'Student Type': m.student_type,
            'Month': m.Month,
            'Present': m.Present,
            'Late': m.Late,
            'Absent': m.Absent,
            'Sent Home': m.SentHome,
            'Sick': m.Sick,
            'Days In school': m.Percentage,
            'Registration Date': m.Regst_date,
            
          };

          finalExportList.push(tempRow);
        });
      } 

        Export_CSV.CsvExport(finalExportList, '', '', 'Attendance report -'+ new Date());
      }
    },
    
    getWorkingDay(month){
      var dt = new Date();
      var year = dt.getFullYear();
      let daysInMonth = new Date(year, month+1, 0).getDate();
      let firstDay = new Date(year, month, 1);
      
      let days =daysInMonth;
      let count = firstDay.getDay()
      let weekends = 0;
      while(days>0){
        if(count ===6 ||count ===7){
          weekends++;
        }
        count++;
        if (count ===8){
          count = 1;
        }
        days--;
      }
      if(month ===2){
        weekends+=5;
      }
      return daysInMonth - weekends;
      
    }

 

  
    
    
  
  
  
}
</script>



<style scoped>

</style>